import React from "react"

import config from "config"

import { useSearchContainer } from "hooks/search/useSearchContainer"
import { SearchPopupContent } from "components/domains/search"
import { VenueFilterBar } from "../../VenueFilterBar"

export const SearchContainer = ({
  showOnscreenKeyboard: showOnscreenKeyboardProp = undefined,
  renderComponent: RenderComponent = SearchPopupContent,
}) => {
  const {
    openSearchState,
    searchInputRef,
    keyboardRef,
    endScrollRef,
    searchResultItems,
    searchValue,
    showOnscreenKeyboard,
    sortedParentCategoryWithOccupant,
    suggestedListItems,
    hasNextPage,
    keyboardLangs,
    onClose,
    onChange,
    onChangeKeyboard,
    onClickCategory,
    onSelectResult,
    onClickClearSearchValue,
    onClickSuggestedItem,
    venueFilter,
    setVenueFilter,
  } = useSearchContainer({ showOnscreenKeyboard: showOnscreenKeyboardProp })

  //TODO:: remove this condition when implement kiosk-v search container to kiosk-h version
  const device = config("device")
  const isKiosk = /^kiosk/.test(device)
  const popupType = isKiosk ? "Dialog" : "Drawer"

  return (
    <React.Fragment>
      <RenderComponent
        keyboardRef={keyboardRef}
        openSearchState={openSearchState}
        searchInputRef={searchInputRef}
        searchResultItems={searchResultItems}
        searchValue={searchValue}
        searchResultProps={{ endScrollRef, hasNextPage }}
        showOnscreenKeyboard={showOnscreenKeyboard}
        onClose={onClose}
        onChange={onChange}
        onChangeKeyboard={onChangeKeyboard}
        onSelectResult={onSelectResult}
        popupType={popupType}
        onClickClearSearchValue={onClickClearSearchValue}
        categories={sortedParentCategoryWithOccupant}
        onClickCategory={onClickCategory}
        suggestedListItems={suggestedListItems}
        onClickSuggestedItem={onClickSuggestedItem}
        inputProps={null}
        closeButtonProps={null}
        closeIconProps={null}
        searchBasePopupProps={null}
        searchKeyboardProps={{ languages: keyboardLangs }}
        venueFilterComponent={
          <VenueFilterBar onClickVenue={setVenueFilter} value={venueFilter} />
        }
      />
    </React.Fragment>
  )
}
